export default "__VITE_ASSET__C7ibpz1P__"